import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIcon from '../Icons/LoadingIcon';

const OrangeLoading: FC<{ full?: boolean; description?: string }> = ({ full, description }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className={`orange-loading ${full ? 'full' : ''}`}>
      <div className="orange-loading-animation">
        <LoadingIcon />
      </div>
      <span className="orange-text">{description || t('orange_loading')}</span>
    </div>
  );
};

export default OrangeLoading;
